import { AppConstants, UnitChart } from '@apps/app.constants';
import { AccessorType } from '@charting/models/accessor.type';

import { Dimensions } from '../dimensions.type';
import { LegendTooltipPos, LegendTooltipPosEnum } from '../legend-tooltip-pos';

export const DefaultConfig = {
    title: {
        draw: true,
        text: ''
    },
    xFormatTick: '%Y',
    yFormatTick: '2',
    rendering: {
        gridHor: true,
        gridVer: true
    },
    dimensions: {
        marginTop: 0,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        height: null, // 300 / AppConstants.GoldenRatio,
        width: null, // 300
    },
    legend: {
        draw: true,
        pos: ''
    },
    type: undefined,
    language: AppConstants.Languages[0],
    xAccessor: (d: any) => d,
    yAccessor: (d: any) => d
} as Config;

export class Rendering
{
    public gridHor: boolean;
    public gridVer: boolean;
}

export class Title
{
    text: string;
    draw: boolean;
}

export class Legend
{
    draw: boolean = true;
    // minX?: number;
    // minY?: number;
    // width?: number;
    // height?: number;
    pos: LegendTooltipPos = LegendTooltipPosEnum.TOP;
}

export class Config
{
    public title: Title;
    public xLabel?: string = '';
    public yLabel?: string = '';
    public xFormatTick: string;
    public yFormatTick: string;
    public rendering: Rendering;
    public dimensions: Dimensions;
    public legend?: Legend;
    public type: UnitChart = undefined;
    public language: string;
    public xAccessor: AccessorType = (d: any) => d;
    public yAccessor: AccessorType = (d: any) => d;

    public static creator (source: any): Config
    {
        const target = new Config();

        Object.assign(target, source);

        return target;
    }
}
